export const LOGIN = "user/LOGIIN";
export const LOGOUT = "user/LOGOUT";
export const FRIENDS_API_ERROR = "user/FRIENDS_API_ERROR";
export const REGISTRATION_SENT = "user/REGISTRATION_SENT";
export const NEW_PASSWORD_SENT = "user/NEW_PASSWORD_SENT";
export const WRONG_CREDENTIALS = "user/WRONG_CREDENTIALS";
export const ALREADY_SENT = "user/ALREADY_SENT";
export const SUBMITTING = "user/SUBMITTNG";
export const FETCH_USER = "user/FETCH_USER";
